import React from "react";

const InfoIcon = () => {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="56"
            height="56"
            viewBox="0 0 56 56"
            fill="none"
        >
            <path
                fill-rule="evenodd"
                clip-rule="evenodd"
                d="M51.3337 28.0013C51.3337 40.8879 40.887 51.3346 28.0003 51.3346C15.1137 51.3346 4.66699 40.8879 4.66699 28.0013C4.66699 15.1147 15.1137 4.66797 28.0003 4.66797C40.887 4.66797 51.3337 15.1147 51.3337 28.0013ZM30.3337 18.668C30.3337 19.9566 29.289 21.0013 28.0003 21.0013C26.7117 21.0013 25.667 19.9566 25.667 18.668C25.667 17.3793 26.7117 16.3346 28.0003 16.3346C29.289 16.3346 30.3337 17.3793 30.3337 18.668ZM25.667 28.0013C25.667 26.7126 26.7117 25.668 28.0003 25.668C29.289 25.668 30.3337 26.7126 30.3337 28.0013V39.668C30.3337 40.9566 29.289 42.0013 28.0003 42.0013C26.7117 42.0013 25.667 40.9566 25.667 39.668V28.0013Z"
                fill="#2096D9"
            />
        </svg>
    );
};

export default InfoIcon;
